import { Button, Text } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { Modal } from '../../elements/modals/Modal';

type HolterClearConfirmModalProps = {
    onNo: () => Promise<void>;
    onYes: () => Promise<void>;
    text: string;
};

export function HolterClearConfirmModal(props: HolterClearConfirmModalProps) {
    const translate = getSelectedLanguage();

    return (
        <Modal
            actionButtons={[
                <Button
                    color="primary"
                    key="no"
                    onClick={async () => await props.onNo()}
                    variant="outline"
                >
                    {translate.common.no}
                </Button>,
                <Button
                    color="primary"
                    key="yes"
                    onClick={async () => await props.onYes()}
                >
                    {translate.common.yes}
                </Button>,
            ]}
            isOpen
            onClose={props.onNo}
            size="small"
            title={translate.holter.clearEcgRecorder}
        >
            <Text>{props.text}</Text>
        </Modal>
    );
}
